module.exports = __webpack_public_path__ + "static/img/m6.02a52cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/mobile/m6.png
// module id = aLM5
// module chunks = 12